(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-home-hero"] && !Shopify.designMode) return;
  try {
    
function dsHeroReduceMotion(root) {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.querySelectorAll('.ds-home-hero__video').forEach(video => {
    video.autoplay = false;
    video.pause();
  });
}
dsHeroReduceMotion(document);
document.addEventListener('shopify:section:load', event => dsHeroReduceMotion(event.target));
window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', () => dsHeroReduceMotion(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    



  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Check initial scroll position on page load
      this.checkInitialScroll();
    }
    
    checkInitialScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = this.header.offsetHeight;
      if (scrollTop > headerHeight) {
        this.header.classList.add('scrolled-past-header');
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      /* Do not hide/reveal the header while its drawer is open */
      if (this.header.classList.contains('menu-open')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pair-builder"] && !Shopify.designMode) return;
  try {
    
  class PairBuilder {
    constructor(root) {
      this.root = root;
      this.products = JSON.parse(root.querySelector('[data-pair-products]')?.textContent || '[]');
      this.selections = [];
      this.busy = false;
      this.selectionLocked = false;
      this.count = root.querySelector('[data-selection-count]');
      this.mobileCount = root.querySelector('[data-mobile-count]');
      this.mobileBar = root.querySelector('[data-mobile-bar]');
      this.slots = root.querySelector('[data-summary-slots]');
      this.deal = root.querySelector('[data-selection-deal]');
      this.error = root.querySelector('[data-pair-error]');
      this.submit = root.querySelector('[data-add-pair]');
      this.mobileSubmit = root.querySelector('[data-mobile-add]');
      this.bind();
      this.restoreUrlSelection();
      this.render();
    }

    bind() {
      this.root.querySelectorAll('[data-select-product]').forEach((button) => button.addEventListener('click', () => this.addSelection(button.closest('[data-product-id]'))));
      this.root.querySelectorAll('[data-variant-select]').forEach((select) => select.addEventListener('change', () => select.closest('[data-product-id]')?.classList.remove('needs-variant')));
      this.submit?.addEventListener('click', () => this.addToCart());
      this.mobileSubmit?.addEventListener('click', () => this.addToCart());
    }

    restoreUrlSelection() {
      const params = new URLSearchParams(window.location.search);
      const productKey = params.get('product');
      const requestedVariantId = Number(params.get('variant'));
      if (!productKey) return;

      const product = this.products.find((item) => String(item.id) === productKey || item.handle === productKey);
      const card = product ? this.root.querySelector(`[data-product-id="${product.id}"]`) : null;
      if (!product || !card) return;

      const requestedVariant = Number.isFinite(requestedVariantId) && requestedVariantId > 0
        ? product.variants.find((variant) => Number(variant.id) === requestedVariantId)
        : null;

      if (requestedVariant && this.inventoryIsValid([{ product, variantId: requestedVariant.id }])) {
        const select = card.querySelector('[data-variant-select]');
        if (select) select.value = String(requestedVariant.id);
        this.selections = [{ product, variantId: requestedVariant.id }];
        return;
      }

      card.classList.add('needs-variant');
      this.showError(this.root.dataset.preselectRequired);
      requestAnimationFrame(() => {
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        card.querySelector('[data-variant-select]')?.focus({ preventScroll: true });
      });
    }

    addSelection(card) {
      if (this.selectionLocked || this.selections.length >= 2) return;
      this.selectionLocked = true;
      window.setTimeout(() => { this.selectionLocked = false; }, 350);
      const product = this.products.find((item) => String(item.id) === card.dataset.productId);
      const variantId = Number(card.querySelector('[data-variant-select]').value);
      const variant = product?.variants.find((item) => Number(item.id) === variantId);
      if (!product || !variant) return;
      const next = [...this.selections, { product, variantId }];
      if (!this.inventoryIsValid(next)) { this.showError(this.root.dataset.inventoryError); return; }
      this.selections = next;
      this.showError('');
      this.render();
    }

    updateSelection(index, variantId) {
      const next = this.selections.map((selection, selectionIndex) => selectionIndex === index ? { product: selection.product, variantId: Number(variantId) } : selection);
      if (!this.inventoryIsValid(next)) { this.showError(this.root.dataset.inventoryError); this.render(); return; }
      this.selections = next;
      this.showError('');
      this.render();
    }

    inventoryIsValid(selections) {
      const quantities = selections.reduce((result, selection) => { result[selection.variantId] = (result[selection.variantId] || 0) + 1; return result; }, {});
      return selections.every((selection) => {
        const variant = selection.product.variants.find((item) => Number(item.id) === Number(selection.variantId));
        return variant && (variant.max === null || quantities[selection.variantId] + variant.inCart <= variant.max);
      });
    }

    removeSelection(index) { this.selections.splice(index, 1); this.showError(''); this.render(); }

    renderCards() {
      this.root.querySelectorAll('[data-product-id]').forEach((card) => {
        const selectedCount = this.selections.filter((selection) => String(selection.product.id) === card.dataset.productId).length;
        const badge = card.querySelector('[data-card-count]');
        card.classList.toggle('is-selected', selectedCount > 0);
        if (badge) { badge.hidden = selectedCount === 0; badge.textContent = selectedCount > 1 ? `${selectedCount}×` : '✓'; }
      });
    }

    render() {
      if (!this.slots) return;
      const selectionText = this.root.dataset.selectedLabel.replace('[count]', this.selections.length);
      this.count.textContent = selectionText;
      if (this.mobileCount) this.mobileCount.textContent = `${this.selections.length}/2`;
      if (this.mobileBar) this.mobileBar.hidden = this.selections.length === 0;
      this.slots.replaceChildren();
      this.selections.forEach((selection, index) => {
        const item = document.createElement('div'); item.className = 'ds-pair-summary__item';
        const title = document.createElement('strong'); title.textContent = selection.product.title;
        const controls = document.createElement('div'); controls.className = 'ds-pair-summary__item-controls';
        const select = document.createElement('select'); select.className = 'ds-pair-summary__variant'; select.setAttribute('aria-label', selection.product.title);
        selection.product.variants.forEach((variant) => { const option = document.createElement('option'); option.value = variant.id; option.textContent = variant.title; option.selected = Number(variant.id) === Number(selection.variantId); select.append(option); });
        select.addEventListener('change', () => this.updateSelection(index, select.value));
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'ds-pair-summary__remove'; remove.textContent = this.root.dataset.removeLabel; remove.addEventListener('click', () => this.removeSelection(index));
        controls.append(select, remove); item.append(title, controls); this.slots.append(item);
      });
      for (let index = this.selections.length; index < 2; index += 1) {
        const empty = document.createElement('p'); empty.className = 'ds-pair-summary__empty';
        const number = document.createElement('b'); number.textContent = `0${index + 1}`;
        const text = document.createElement('span'); text.textContent = this.root.dataset.addLabel;
        empty.append(number, text); this.slots.append(empty);
      }
      const valid = this.selections.length === 2 && this.inventoryIsValid(this.selections);
      this.submit.disabled = !valid || this.busy;
      if (this.mobileSubmit) this.mobileSubmit.disabled = !valid || this.busy;
      const total = this.selections.reduce((sum, selection) => { const variant = selection.product.variants.find((item) => Number(item.id) === Number(selection.variantId)); return sum + (variant?.price || 0); }, 0);
      this.deal.textContent = valid && total === Number(this.root.dataset.expectedTotal) ? this.root.dataset.fixedDeal : this.root.dataset.selectedLabel.replace('[count]', this.selections.length);
      this.renderCards();
    }

    showError(message) { if (!this.error) return; this.error.textContent = message; this.error.hidden = !message; }

    setSubmitText(text) {
      const desktopText = this.submit?.querySelector('span');
      if (desktopText) desktopText.textContent = text;
      if (this.mobileSubmit) this.mobileSubmit.firstChild.textContent = `${text} `;
    }

    async addToCart() {
      if (this.busy || this.selections.length !== 2 || !this.inventoryIsValid(this.selections)) return;
      this.busy = true; this.setSubmitText(this.root.dataset.addingLabel); this.render();
      const quantities = this.selections.reduce((result, selection) => { result[selection.variantId] = (result[selection.variantId] || 0) + 1; return result; }, {});
      const items = Object.entries(quantities).map(([id, quantity]) => ({ id: Number(id), quantity }));
      const cartDrawer = document.querySelector('cart-drawer');
      const payload = { items };
      if (cartDrawer?.getSectionsToRender) { payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id); payload.sections_url = window.location.pathname; }
      try {
        const response = await fetch(this.root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.root.dataset.cartError);
        if (cartDrawer?.renderContents && result.sections) { cartDrawer.setActiveElement?.(this.submit); cartDrawer.renderContents(result); }
        else { window.location.assign(this.root.dataset.cartUrl); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pair-builder', cartData: result });
      } catch (error) { this.showError(error.message || this.root.dataset.cartError); }
      finally { this.busy = false; this.setSubmitText(this.root.dataset.submitLabel); this.render(); }
    }
  }
  document.querySelectorAll('[data-pair-builder]').forEach((root) => new PairBuilder(root));

  } catch(e) { console.error(e); }
})();
})();
